module.exports = __webpack_public_path__ + "static/media/chat13.4900d564.gif";